/**
 * --------------------------------------------------
 * !!! THIS FILE WAS GENERATED BY GRAPHQL-CODEGEN !!!
 * !!!   DO NOT MODIFY THIS FILE BY YOURSELF      !!!
 * --------------------------------------------------
 */

import * as c from "@hex/common";
import type * as Types from "../../generated/graphqlTypes";

import { gql } from "@apollo/client";
import { HexListFragmentDoc } from "../hex-list/HexList.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetHexesForRecentSidebarItemsQueryVariables = Types.Exact<{
  onlyViewed: Types.InputMaybe<Types.Scalars["Boolean"]["input"]>;
  order: Types.InputMaybe<Types.HexOrder>;
  first: Types.InputMaybe<Types.Scalars["Int"]["input"]>;
}>;

export type GetHexesForRecentSidebarItemsQuery = {
  readonly __typename: "Query";
  readonly hexes: {
    readonly __typename: "HexesConnection";
    readonly pageInfo: {
      readonly __typename: "PageInfo";
      readonly hasPreviousPage: boolean;
      readonly hasNextPage: boolean;
      readonly startCursor: c.Cursor | null;
      readonly endCursor: c.Cursor | null;
    };
    readonly edges: ReadonlyArray<{
      readonly __typename: "HexesEdge";
      readonly node: {
        readonly __typename: "Hex";
        readonly id: c.HexId;
        readonly lastViewedByMe: c.DateTimeString | null;
        readonly userUpdatedDate: c.DateTimeString;
        readonly trashDate: c.DateTimeString | null;
        readonly title: string;
        readonly description: c.RichTextDocument | null;
        readonly canShare: boolean;
        readonly maxGrantableRole: Types.ProjectRole | null;
        readonly canViewLogic: boolean;
        readonly effectiveRole: Types.ProjectRole | null;
        readonly starredByViewer: boolean;
        readonly hexType: Types.HexType;
        readonly projectLanguage: Types.ProjectLanguage;
        readonly canDelete: boolean;
        readonly canSetOwner: boolean;
        readonly canEdit: boolean;
        readonly canEditorsShare: boolean;
        readonly archivedDate: c.DateTimeString | null;
        readonly unarchivedDate: c.DateTimeString | null;
        readonly publicRoleV2: Types.ProjectRole | null;
        readonly organizationRoleV2: Types.ProjectRole | null;
        readonly grantSummary: c.ProjectGrantSummary;
        readonly onlyGrantedToCurrentUser: boolean;
        readonly totalViewCount: number;
        readonly currentDraft: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
          readonly createdDate: c.DateTimeString;
          readonly title: string;
          readonly logicSessionId: c.AppSessionId;
          readonly canEdit: boolean;
          readonly denialReason:
            | {
                readonly __typename: "AssetAccess";
                readonly hasAccessToSharedDataConnections: boolean;
                readonly hasAccessToSharedFiles: boolean;
                readonly hasAccessToSharedPackages: boolean;
                readonly hasAccessToSharedSecrets: boolean;
                readonly hasAccessToSharedSyncRepositories: boolean;
              }
            | { readonly __typename: "MissingProjectRole" }
            | null;
        };
        readonly creator: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly status: {
          readonly __typename: "Status";
          readonly id: c.StatusId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
          readonly inLibrary: boolean;
          readonly endorsed: boolean;
          readonly icon: Types.IconType | null;
        } | null;
        readonly categories: ReadonlyArray<{
          readonly __typename: "Category";
          readonly id: c.CategoryId;
          readonly name: string;
          readonly color: Types.HexColor;
          readonly description: string | null;
        }>;
        readonly lastPublishedVersion: {
          readonly __typename: "HexVersion";
          readonly id: c.HexVersionId;
        } | null;
        readonly owner: {
          readonly __typename: "User";
          readonly id: c.UserId;
          readonly name: string | null;
          readonly email: string;
        };
        readonly org: {
          readonly __typename: "Org";
          readonly id: c.OrgId;
          readonly displayName: string;
          readonly allowPublicSharing: boolean;
          readonly resolvedAllowPublicSharing: boolean;
        };
        readonly projectAnalytics: {
          readonly __typename: "HexAnalytics";
          readonly id: c.HexAnalyticsId;
          readonly totalViewsLast7Days: number;
          readonly totalViewsLast14Days: number;
          readonly totalViewsLast30Days: number;
        };
      };
    }>;
  };
};

export const GetHexesForRecentSidebarItemsDocument = /*#__PURE__*/ gql`
  query GetHexesForRecentSidebarItems(
    $onlyViewed: Boolean
    $order: HexOrder
    $first: Int
  ) {
    hexes(
      ownershipLevel: ALL
      onlyPublished: false
      onlyStarred: false
      onlyViewed: $onlyViewed
      order: $order
      trashed: false
      first: $first
      hexTypes: [PROJECT, COMPONENT]
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          lastViewedByMe
          ...HexListFragment
        }
      }
    }
  }
  ${HexListFragmentDoc}
`;

/**
 * __useGetHexesForRecentSidebarItemsQuery__
 *
 * To run a query within a React component, call `useGetHexesForRecentSidebarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHexesForRecentSidebarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHexesForRecentSidebarItemsQuery({
 *   variables: {
 *      onlyViewed: // value for 'onlyViewed'
 *      order: // value for 'order'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetHexesForRecentSidebarItemsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >(GetHexesForRecentSidebarItemsDocument, options);
}
export function useGetHexesForRecentSidebarItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >(GetHexesForRecentSidebarItemsDocument, options);
}
export function useGetHexesForRecentSidebarItemsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetHexesForRecentSidebarItemsQuery,
    GetHexesForRecentSidebarItemsQueryVariables
  >(GetHexesForRecentSidebarItemsDocument, options);
}
export type GetHexesForRecentSidebarItemsQueryHookResult = ReturnType<
  typeof useGetHexesForRecentSidebarItemsQuery
>;
export type GetHexesForRecentSidebarItemsLazyQueryHookResult = ReturnType<
  typeof useGetHexesForRecentSidebarItemsLazyQuery
>;
export type GetHexesForRecentSidebarItemsSuspenseQueryHookResult = ReturnType<
  typeof useGetHexesForRecentSidebarItemsSuspenseQuery
>;
export type GetHexesForRecentSidebarItemsQueryResult = Apollo.QueryResult<
  GetHexesForRecentSidebarItemsQuery,
  GetHexesForRecentSidebarItemsQueryVariables
>;
